import PropTypes from "prop-types"

import Modal from "shared/components/modal"

import "../upgrade_to_pro_modal/modal.scss"

const DelayModal = ({ visible, onClose }) => {
  return (
    <div styleName="modal-container">
      <Modal show={visible} includeCloseX={false}>
        <h2>Delay is here!</h2>
        <p className="txt-body-3">
          Now you can add delay to your Applets.
          <br />
          Check it out by adding a trigger.
        </p>
        <div className="action-buttons-container">
          <button className="button-tertiary" onClick={onClose}>
            Got it. Thanks!
          </button>
        </div>
      </Modal>
    </div>
  )
}

DelayModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default DelayModal
